import { KnowledgeBaseArticleService } from './knowledge-base-article-service';
import { queryClient } from '../query-client';
export const knowledgeBaseArticleService = new KnowledgeBaseArticleService({
    resource: 'knowledge-base-article',
    parentResources: [],
    middleware: [],
    queryClient,
});
